import styled from 'styled-components';
import Wra16D from 'dc/Wra16D';
import Wra16A from 'dc/Wra16A';

export const Header = styled(Wra16D)`
  width: 100%;
  height: 38px;
`;

export const BubblesWrapper = styled(Wra16A)`
  background-color: transparent;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 272px;
  display: flex;
  flex: 1;
`;
